export function getEndpointForNavigation(): string {
    return '/navigate';
}
